import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import styles from '@src/styles/components/menu-desktop.scss';
import Translation from '../Base/Translation';

export default class MenuPrimaryPopup extends React.Component {

    constructor(props) {

        super(props);

        this.elementRef = React.createRef();

        this.state = {
            selected: props.items[0] ?? null,
            minHeight: 0,
        };
    }

    static get propTypes() {

        return {
            link: PropTypes.string,
            items: PropTypes.any,
        };
    }

    render() {

        const
            { items } = this.props,
            { minHeight } = this.state;

        return (
            <div className={ css('menu-popup', styles) } style={{ minHeight }} ref={ this.elementRef }>

                {/* secondary */}
                <div className={ css('menu-popup__secondary', styles)}>
                    { items.map((item, index) => this.renderSecondary(item, index)) }
                    { this.renderPrimaryLink() }
                </div>

                {/* selected */}
                { this.renderSelectedBody() }

            </div>
        );
    }

    // eslint-disable-next-line object-curly-newline
    renderSecondary({ anchor, link, columns, services }, index) {

        const id = `secondaryDesktop${index}`;

        if (link)
            return <a key={ id } className={ css('menu-popup__secondary-item', styles) } href={ link }>{ anchor }</a>;

        return (
            <div key={ id } className={ css('menu-popup__secondary-item', styles) } onMouseEnter={ () => this.handleSecondaryEnter({ link, columns, services }) }>
                { anchor }
            </div>
        );
    }

    renderPrimaryLink() {

        const { link } = this.props;

        return (
            <>
                <div className={ css('flex-1') }></div>
                <a className={ css('menu-popup__secondary-item flex items-center gap text-primary') } href={ link }>
                    <Translation tag='menu.go-to-section' />
                    <svg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M0.52827 0.861919C0.788619 0.601569 1.21073 0.601569 1.47108 0.861919L6.13775 5.52858C6.3981 5.78893 6.3981 6.21104 6.13775 6.47139L1.47108 11.1381C1.21073 11.3984 0.788619 11.3984 0.52827 11.1381C0.26792 10.8777 0.26792 10.4556 0.52827 10.1953L4.72353 5.99999L0.52827 1.80473C0.26792 1.54438 0.26792 1.12227 0.52827 0.861919Z' fill='#1373E5'/></svg>
                </a>
            </>
        );
    }

    renderSelectedBody() {

        if (!this.state.selected)
            return null;

        const { columns, services } = this.state.selected;

        return (
            <>
                { this.renderColumns(columns) }
                { this.renderServices(services) }
            </>
        );
    }

    renderColumns(columns) {

        if (!columns)
            return <div className={ css('menu-popup__body', styles)}></div>;

        return (
            <div className={ css('menu-popup__body', styles)} style={{ '--columns': columns.length }}>
                { columns.map((item, index) => this.renderColumn(item, index)) }
            </div>
        );
    }

    renderColumn({ anchor, items }, key) {

        return (
            <div key={ key } className={ css('flex flex-wrap px-4 content-start') }>
                <div className={ css('w-full text-medium menu-popup__column-item', styles) }>{ anchor }</div>
                { items.map((item, index) => this.renderColumnItem(item, index)) }
            </div>
        );
    }

    renderColumnItem({ anchor, link }, index) {

        return (
            <a key={ index } href={ link } className={ css('menu-popup__column-item', styles) }>
                { anchor }
            </a>
        );
    }

    renderServices(services) {

        if (!services)
            return null;

        return (
            <div className={ css('menu-popup__services', styles)}>
                { services.map((item, index) => this.renderServiceItem(item, index)) }
            </div>
        );
    }

    // eslint-disable-next-line object-curly-newline
    renderServiceItem({ anchor, link, iconLink, isButton, isBlankLink }, index) {

        const classes = [
            'menu-popup__services_item',
        ];

        if (isButton)
            classes.push('menu-popup__services_item--button');

        const props = {};
        if (isBlankLink)
            props['target'] = '_blank';

        return (
            <a key={ index } href={ link } className={ css(classes.join(' '), styles) } { ...props }>
                <img className={ css('size-x-32 aspect-square') } alt={ anchor } src={ iconLink } />
                { anchor }
            </a>
        );
    }

    handleSecondaryEnter(selected) {

        this.setState({ selected }, () => {

            const element = this.elementRef.current;
            if (element != undefined) {

                const height = parseInt(element.getBoundingClientRect().height, 10);
                if (this.state.minHeight < height)
                    this.setState({ minHeight: height });
            }
        });
    }

}